<template>
  <section>
    <template>
      <v-flex xs12 md12 class="top-banner">
        <v-carousel
          v-if="info.banners"
          cycle
          hide-delimiter-background
          delimiter-icon=""
          :show-arrows="false"
          :height="height"
        >
          <v-carousel-item
            v-for="(slider, i) in info.banners"
            :key="i"
            :src="slider.img"
          ></v-carousel-item>
        </v-carousel>
      </v-flex>
      <v-layout wrap mt-12 class="max-width-div">
        <v-flex xs12 md12 mb-8 class="xs-pd">
          <p class="home-h1" id="profile">集团简介</p>
          <p class="home-p">德硅集团（Citiking Group）是一家快速成长的多元化企业集团，专注于将欧洲制造商的高端建材、装饰和整体家居产品提供给中国用户。 德硅将多项欧洲优秀的技术、材料、理念，以及高品质的成熟产品引进到中国，用适合的解决方案满足当今中国建筑及装饰领域高速发展的广泛市场需求。作为致力于将欧洲高端产品引进中国的集成商，德硅集团在日常运营和业务实践过程中，针对性的在供货周期、定制服务及售后保障等诸多方面对欧洲产品进行了本土优化，为中国客户提供了可靠性及成本效率均达到世界水平的建筑、装饰及整体家居工程综合解决方案。 德硅致力于让生活更美好的事业，承诺并始终在为中国人拥有更加健康、更高品质的居住环境而不懈努力。</p>
        </v-flex>
        <v-flex xs12 md12 pl-md-12 pr-md-12>
          <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/group/home-center.png"></v-img>
        </v-flex>
      </v-layout>
      <v-flex xs12 md12 style="background:#f0f2f5;">
        <v-layout wrap mt-12 class="max-width-div">
          <v-flex xs6 md6 pt-10 pb-3 class="xs-pd">
            <p class="home-h1" id="news">集团动态</p>
          </v-flex>
          <v-flex xs6 md6 pt-10 pb-3 text-right class="home-more">
            <a href="/news">查看更多 〉 </a>
          </v-flex>
          <v-flex xs12 md12>
            <v-layout wrap v-if="info.news[0]" class="news-div">
              <v-flex xs12 md6>
                <v-img :src="info.news[0].img" aspect-ratio="1.62"></v-img>
              </v-flex>
              <v-flex xs12 md6 pt-md-10 pl-md-12 class="pd-div" style="position: relative; min-height: 200px;">
                <p class="news-date">{{info.news[0].create_time}}</p>
                <p class="news-title-1">{{info.news[0].title}}</p>
                <p class="news-desc hidden-sm-and-down">{{info.news[0].profile}}</p>
                <a :href="'/new/' + info.news[0].id" class="news-detail-btn">查看详情</a>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md4 pr-md-6 v-if="info.news[1]">
            <a :href="'/new/' + info.news[1].id" class="news-a">
              <v-img :src="info.news[1].img" aspect-ratio="1.62"></v-img>
              <div class="news-div pd-div">
                <p class="news-date">{{info.news[1].create_time}}</p>
                <p class="news-title">{{info.news[1].title}}</p>
              </div>
            </a>
          </v-flex>
          <v-flex xs12 md4 pl-md-3 pr-md-3 v-if="info.news[2]">
            <a :href="'/new/' + info.news[2].id" class="news-a">
              <v-img :src="info.news[2].img" aspect-ratio="1.62"></v-img>
              <div class="news-div pd-div">
                <p class="news-date">{{info.news[2].create_time}}</p>
                <p class="news-title">{{info.news[2].title}}</p>
              </div>
            </a>
          </v-flex>
          <v-flex xs12 md4 pl-md-6 v-if="info.news[3]">
            <a :href="'/new/' + info.news[3].id" class="news-a">
              <v-img :src="info.news[3].img" aspect-ratio="1.62"></v-img>
              <div class="news-div pd-div">
                <p class="news-date">{{info.news[3].create_time}}</p>
                <p class="news-title">{{info.news[3].title}}</p>
              </div>
            </a>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md12 style="background: url(https://ctk-website.oss-cn-shanghai.aliyuncs.com/group/values-bg.png) no-repeat left top !important;">
        <v-layout wrap class="max-width-div">
          <v-flex xs12 md12 class="xs-pd values-h">
            <p class="home-h1" id="values">价值观</p>
          </v-flex>
          <v-flex xs12 md12 class="home-values" style="margin-bottom: 130px;">
            <v-carousel cycle hide-delimiter-background hide-delimiters height="auto">
              <template v-slot:prev="{ on, attrs }">
                <v-btn
                  depressed
                  color="#dfe1e6"
                  v-bind="attrs"
                  v-on="on"
                  class="values-btn"
                >
                  <v-icon>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:next="{ on, attrs }">
                <v-btn
                  depressed
                  color="#dfe1e6"
                  v-bind="attrs"
                  v-on="on"
                  class="values-btn"
                >
                  <v-icon dark>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </template>
              <v-carousel-item
                v-for="v in values"
                :key="v.nu"
              >
                <v-layout wrap>
                  <v-flex xs12 sm12 md5 text-left class="xs-pd" style="display:flex; align-items: center;">
                    <div>
                      <h3 class="values-title">{{ v.title }}</h3>
                      <div class="values-line"></div>
                      <div class="values-content" v-html="v.content"> {{ v.content }} </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 md7 pl-md-12>
                    <v-img
                      width="100%"
                      max-height="600"
                      :src="'https://ctk-website.oss-cn-shanghai.aliyuncs.com/group/'+v.pic"
                    >
                    </v-img>
                  </v-flex>
                </v-layout>
              </v-carousel-item>
            </v-carousel>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md12 style="background: url(https://ctk-website.oss-cn-shanghai.aliyuncs.com/group/history-bg.png) repeat-x left top !important;background-size: contain;">
        <v-layout wrap mt-12 class="max-width-div">
          <v-flex md12 mb-8 class="xs-pd">
            <p class="home-h1" id="history">发展历程</p>
          </v-flex>
          <v-flex md12>
            <v-layout wrap>
              <v-flex md5 pr-md-2 mb-8>
                <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/group/history.png" max-height="600" contain position="left top"></v-img>
              </v-flex>
              <v-flex md7 pl-md-2>
                <ul class="history-ul">
                  <li v-for="t in info.timeline" :key="'t'+t.ymd">
                    <div style="float:left;width: calc(100% - 120px);"><p class="history-content" v-html="t.desc">{{ t.desc }}</p></div>
                    <div style="width: 100px; height: 36px; float:right;"><p class="history-date">{{ t.ymd }}</p></div>
                  </li>
                </ul>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-layout wrap class="max-width-div" style="margin-top: 60px;">
        <v-flex xs12 md12 class="xs-pd" style="margin-bottom: 20px;">
          <p class="home-h1" id="subsidiary">集团子公司</p>
        </v-flex>
        <v-flex xs6 md3 pb-12 pl-12 pr-12 v-for="lk in info.link" :key="'p'+lk.id" class="home-link">
          <a :href="lk.url">
            <v-img
              contain
              position="center center"
              :src="lk.logo"
              height="140"
            >
            </v-img>
            <p class="link-title">{{lk.title}}</p>
          </a>
        </v-flex>
      </v-layout>
    </template>
  </section>
</template>

<script>
export default {
  data: () => ({
    isMobile: false,
    pageId: 0,
    height: 0,
    values: [
      { nu: 1, title: '可持续发展的技术、产品和服务', pic: 'v1.png', content: '德硅集团为安全、健康、舒适和品质尽最大责任：为我们的客户、我们的员工、和我们所在的区域营造一个安全和高效的环境。</br>我们力求提供能够满足每一位客户质量期望的产品和服务，确保客户满意度和忠诚度。我们始终在倾尽全力开发和推广兼顾环保和可持续发展的技术、产品和服务。' },
      { nu: 2, title: '探索和开发新的技术及应用', pic: 'v2.png', content: '每一天，我们向客户提供的产品和服务通过不同的行业触及众人的生活，我们将继续为我们的客户探索和开发新的技术及应用，从而造福于更多的中国用户。' },
      { nu: 3, title: '坚持质量第一，时间证明价值', pic: 'v3.png', content: '◆  提供建材行业领域打包整合方案<br/>◆  旗下产品和技术从欧洲引进，严格执行德国工业标准<br/>◆  进入中国建材行业多个领域十余年，行业经验丰富而多样化<br/>◆  把企业文化和经营理念放在首位，坚持质量第一，时间证明价值<br/>◆  秉承欧洲管理理念，始终是一个学习成长型的团队<br/>◆  对未来发展有执着坚定的信念，立足长远 ' }
    ]
  }),
  created () {
    this.height = document.body.offsetHeight - 104
    if (window.innerWidth < 960) {
      this.isMobile = true
      this.height = 240
    }
  },
  mounted: function () {
    // 跳转到锚点
    if (this.$route.hash) {
      let id = this.$route.hash.slice(1)
      let el = document.getElementById(id)
      document.body.scrollTop = el.offsetTop
      document.documentElement.scrollTop = el.offsetTop
      window.pageYOffset = el.offsetTop
    }
  },
  watch: {
    '$store.getters.companyInfo': {
      handler: function (val, oldVal) {
        this.$nextTick(function () {
        })
      },
      deep: true
    }
  },
  computed: {
    info () {
      let banners = {}
      let news = []
      let timeline = []
      let link = []
      banners[this.pageId] = []
      if (this.$store.getters.companyInfo.banner) {
        banners = this.$store.getters.companyInfo.banner[this.pageId]
      }
      if (this.$store.getters.companyInfo.news) {
        news = this.$store.getters.companyInfo.news[2]
      }
      if (this.$store.getters.companyInfo.timeline) {
        timeline = this.$store.getters.companyInfo.timeline
        timeline = timeline.reverse()
      }
      if (this.$store.getters.companyInfo.link) {
        link = this.$store.getters.companyInfo.link
      }
      return {
        banners: banners,
        news: news,
        timeline: timeline,
        link: link
      }
    }
  },
  methods: {
  }
}
</script>
<style lang="css">
  @import '../css/home.css';
</style>
